import Vue from 'vue';
import VueRouter from 'vue-router';
import Home from '../views/Home.vue';
import Privacy from '../views/Privacy.vue';
import DeleteAccount from '../views/DeleteAccount.vue';

Vue.use(VueRouter);

const routes = [
  {
    path: '/',
    meta: {
      title: 'ULaw - SQE Question Redemption'
    },
    component: Home
  },
  {
    path: '/privacy',
    meta: {
      title: 'ULaw - SQE Privacy & Terms'
    },
    component: Privacy
  },
  {
    path: '/delete-account',
    meta: {
      title: 'ULaw SQE App - Request account deletion'
    },
    component: DeleteAccount
  },
  {
    path: '/:code',
    meta: {
      title: 'ULaw - SQE Question Redemption'
    },
    component: Home
  }
];

const router = new VueRouter({
  hash: false,
  mode: 'history',
  routes
});

export default router;
